import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import bg from '../assets/images/hero/contacto.jpg'
import Eventcontact from '../components/eventcontact'
import sanitizeHtml from 'sanitize-html'
import useCsrfToken from '../hooks/useCsrfToken'

export default function Eventoregistro() {
    const { csrfToken } = useCsrfToken();
    const [listing, setListing] = useState([]);
    const [tags, setTags] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;
    let params = useParams();
    let listingid = params.listingid;
    let slug = params.slug;
    const stripTagsFromHtml = (html) => {
        const allowedTags = ['b', 'u', 'i', 'p', 'br', 'span', 'strong', 'em', 'a'];
        return sanitizeHtml(html, {
            allowedTags: allowedTags
        });
    };
    useEffect(() => {
        // if (csrfToken === null) return;
        const transformData = (data) => {
            return {
                id: data.id,
                image: `${API_URL}${data.primary_image}`,
                tag: 'Eventos',
                name: data.title,
                slug: data.slug,
                intro: data.intro !== '' ? stripTagsFromHtml(data.intro) : '',
                desc: data.description !== '' ? stripTagsFromHtml(data.description) : '',
                tags: data.tags,
                gallery: data.gallery?.gallerythumbs,
                gallerylarge: data.gallery?.galleryimages,
                brochure_url: data.brochure_url,
                cta_url: data.cta_url,
                phone_1: data.phone_1,
                title: data.title,
                listing_type: data.listing_type,
                embed: data.embed,
                branches: data.branches,
                terms: data.terms !== '' ? stripTagsFromHtml(data.terms) : '',
                rules: data.rules !== '' ? stripTagsFromHtml(data.rules) : '',
                eventdate: data.fulleventdate,
                eventstart: data.eventstartdate,
                eventend: data.eventenddate,
                event_type: data.event_type,
                price: data.price
            };
        };
        fetch(`${API_URL}/api/listing/${slug}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'X-CSRF-TOKEN': csrfToken,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.json())
            .then(data => {
                setListing(transformData(data))
            })
            .catch(error => console.error('Error fetching data:', error));
        fetch(`${API_URL}/api/filtertags`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'X-CSRF-TOKEN': csrfToken,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.json())
            .then(data => setTags(Array.isArray(data) ? data : Object.values(data)))
            .catch(error => console.error('Error fetching data:', error));
    }, [API_URL, slug, csrfToken]);

    // console.log('listing', listing);
    // console.log('tags', tags);
    return (
        <>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${listing.image != null ? listing.image : bg})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Registro para evento</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item" aria-current="page"><Link to="/eventos">eventos</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Registro</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <Eventcontact listing={listing} listingid={listingid} tags={tags} />
            <section className="section pb-0 pt-0">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 p-0">
                            <div className="card map border-0">
                                <div className="card-body p-0">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4807.161320824865!2d-101.68416112377942!3d21.125587980548026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842bbf0cfb3510db%3A0x4f041cca7c9d6540!2sHospital%20Aranda%20de%20la%20Parra!5e1!3m2!1ses-419!2smx!4v1731509700156!5m2!1ses-419!2smx" style={{ border: '0' }} allowFullScreen title="HAP"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </>
    )
}
